import r from"./grid";import t from"./grid-container";export{StyledGridContainer,StyledGridItem}from"./grid.styles";r.Container=t;export default r;